import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { AddNewClientPanel } from 'components/sidebar/client-profile/overview/add/AddNewClientPanel.component';
import fromAnyToString from 'utils/converters/fromAnyToString';
import logger from 'utils/logger.util';

import { pickClient } from 'booking/actions';

const L = logger('AddNewClient');

export const AddNewClient = ({ match }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const pathname = location?.pathname || '';

  const initialName = useMemo(() => {
    const nameFromParams = match?.params?.name;
    if (nameFromParams) return nameFromParams;

    const parts = pathname.split('new/client/new/');
    if (parts.length > 1) return decodeURIComponent(parts[1].replace(/\/$/, ''));

    return '';
  }, [match?.params?.name, pathname]);

  const onSuccess = useCallback(
    (response) => {
      L.info('onSuccess()', 'Client created, handling navigation', { response });

      dispatch(pickClient(response));

      const segments = pathname.split('/');

      if (pathname.includes('appointment')) {
        const newIndex = segments.indexOf('new');
        const chopped = segments.slice(0, newIndex).join('/');
        const subPath = newIndex >= 0 ? '/new/services' : '/summary';
        history.push(`${chopped}${subPath}`);
        return;
      }

      const voucherState = location?.state;
      if (voucherState?.fromVoucher) {
        const userName = fromAnyToString(response?.user_name);
        history.push({
          pathname: voucherState.fromVoucher,
          state: {
            newClientName: userName,
            isRecipient: voucherState.isRecipient,
            isPurchaser: voucherState.isPurchaser,
          },
        });
        return;
      }

      const createIndex = segments.indexOf('create');
      if (createIndex >= 0) {
        const chopped = segments.slice(0, createIndex).join('/');
        const responseId = fromAnyToString(response?.id);
        history.push(`${chopped}/client/${responseId}`);
        return;
      }

      history.goBack();
    },
    [dispatch, history, location?.state, pathname],
  );

  const onBack = useCallback(() => {
    history.goBack();
  }, [history]);

  return (
    <div className="BookingWindow">
      <AddNewClientPanel initialName={initialName} onSuccess={onSuccess} onBack={onBack} />
    </div>
  );
};
